package fyi.moko.hotpl.domain.model

private val repeatedWhitespace = "\\s+".toRegex()

fun normalizeForComparison(value: String): String =
    value.trim().lowercase().replace(repeatedWhitespace, " ")

fun normalizePlaceNameForStorage(value: String): String =
    value.trim().replace(repeatedWhitespace, " ")

fun normalizeTags(tags: List<String>): List<String> =
    tags.map(::normalizeForComparison).filter { it.isNotEmpty() }.distinct()
